import React, { useEffect, useState } from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import UsersTab from './UsersTab';
import RolesTab from './RolesTab';

export default function TeamManagementSection() {
  const defaultSubtab = 'roles';

  const [searchParams, setSearchParams] = useSearchParams();
  const subtabFromUrl = searchParams.get('subtab') || defaultSubtab;
  const activeSubtab = subtabFromUrl === 'roles' ? 'roles' : 'users';
  const [subtab, setSubtab] = useState(activeSubtab);

  useEffect(() => {
    setSubtab(activeSubtab);
    if (subtabFromUrl !== activeSubtab) {
      setSearchParams({ tab: 'team', subtab: activeSubtab });
    }
  }, [activeSubtab, subtabFromUrl, setSearchParams]);

  const handleSubtabChange = (_event, newValue) => {
    setSubtab(newValue);
    setSearchParams({ tab: 'team', subtab: newValue });
  };

  return (
    <Box>
      <Box
        sx={{
          display: 'inline-flex',
          bgcolor: 'rgba(255, 255, 255, 0.06)',
          borderRadius: 1.5,
          p: 0.25,
        }}
      >
        <Tabs
          value={subtab}
          onChange={handleSubtabChange}
          sx={{
            minHeight: 'unset',
            '& .MuiTabs-scroller': { display: 'flex', alignItems: 'center' },
            '& .MuiTabs-indicator': { display: 'none' },
            '& .MuiTabs-flexContainer': { gap: 0.25, alignItems: 'center' },
            '& .MuiTab-root': {
              minWidth: 'auto',
              height: 28,
              minHeight: 28,
              py: 0,
              px: 1.5,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              lineHeight: 1.2,
              textTransform: 'uppercase',
              fontSize: '0.75rem',
              fontWeight: 500,
              letterSpacing: '0.02em',
              color: 'text.secondary',
              borderRadius: 1,
            },
            '& .MuiTab-root.Mui-selected': {
              color: '#ECEEF1',
              bgcolor: 'rgba(255, 255, 255, 0.12)',
              boxShadow: 'none',
            },
          }}
        >
          <Tab value="roles" label="Roles & Permissions" />
          <Tab value="users" label="Users" />
        </Tabs>
      </Box>
      <Box sx={{ pt: 2 }}>
        {subtab === 'roles' && <RolesTab />}
        {subtab === 'users' && <UsersTab />}
      </Box>
    </Box>
  );
}
